import { render, staticRenderFns } from "./BannerPreview.vue?vue&type=template&id=044b1562&scoped=true&"
import script from "./BannerPreview.vue?vue&type=script&lang=ts&"
export * from "./BannerPreview.vue?vue&type=script&lang=ts&"
import style0 from "./BannerPreview.vue?vue&type=style&index=0&id=044b1562&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044b1562",
  null
  
)

export default component.exports